exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-container[data-v-8c2fb426] {\n  padding: 0 0.75rem 1rem;\n}\n.filter-container a[data-v-8c2fb426] {\n  font-size: 0.875rem !important;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  border-radius: 10rem;\n  cursor: pointer;\n  font-weight: 400;\n}\n.filter-container a[data-v-8c2fb426]:hover, .filter-container a.current[data-v-8c2fb426] {\n  border: 0;\n  background: #fff;\n}", ""]);

// exports
